import store from "@/state/store";
import { hasPermission, nextAllowPage } from '@/helpers/permission';

export default [
    {
        path: "/",
        name: "default",
        meta: { authRequired: true },
        component: () => import("./views/dashboards/default.vue"),
        beforeEnter: (to, from, next) => {
            if (hasPermission(['dashboard-view'])) {
                next();
            } else {
                next(nextAllowPage());
            }
        }
    },
    {
        path: "/dashboard",
        name: "dashboard",
        meta: { authRequired: true },
        component: () => import("./views/dashboards/default.vue"),
        beforeEnter: (to, from, next) => {
            if (hasPermission(['dashboard-view'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: '/customers',
        name: 'Customers',
        component: () => import('./views/customers/Table.vue'),
        meta: { authRequired: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['customers-all', 'customers-view'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: '/products',
        name: 'Products',
        component: () => import('./views/products/Table.vue'),
        meta: { authRequired: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['products-all', 'products-view'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: '/orders',
        name: 'Orders',
        component: () => import('./views/orders/Table.vue'),
        meta: { authRequired: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['order-all', 'order-view'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: '/order/add',
        name: 'AddOrder',
        component: () => import('./views/orders/AddEdit.vue'),
        meta: { authRequired: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['order-all', 'order-create'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: '/order/:id',
        name: 'OrderDetail',
        component: () => import('./views/orders/View.vue'),
        meta: { authRequired: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['order-all', 'order-view'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: '/order/edit/:id',
        name: 'EditOrder',
        component: () => import('./views/orders/AddEdit.vue'),
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['order-all', 'order-edit'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: '/order-products',
        name: 'OrderProducts',
        component: () => import('./views/orderProduct/Table.vue'),
        meta: { authRequired: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['order-product-all', 'order-product-view'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: "/login",
        name: "login",
        component: () => import("./views/account/login.vue"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters["authApi/loggedIn"]) {
                    next({ name: "default" });
                } else {
                    next();
                }
            },
        },
    },
    {
        path: '/profile',
        name: 'UserProfile',
        component: () => import('./views/profile/profile.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/users",
        name: "Users",
        component: () => import("./views/users-management/users/Table.vue"),
        meta: { authRequired: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['users-all', 'users-view'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: '/users/edit/:id',
        name: 'EditUser',
        component: () => import('./views/users-management/users/Edit.vue'),
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['users-all', 'users-edit'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: '/users/add',
        name: 'AddUser',
        component: () => import('./views/users-management/users/Add.vue'),
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['users-all', 'users-create'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: "/roles",
        name: "Roles",
        component: () => import("./views/users-management/roles/Roles.vue"),
        meta: { authRequired: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['roles-all', 'roles-view'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: '/roles/:id/edit',
        name: 'EditRole',
        component: () => import('./views/users-management/roles/AddEditRole.vue'),
        meta: { title: 'Edit Role' },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['roles-all', 'roles-edit'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: '/roles/add',
        name: 'AddRole',
        component: () => import('./views/users-management/roles/AddEditRole.vue'),
        meta: { title: 'Add Role' },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['roles-all', 'roles-create'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: "/permissions",
        name: "Permissions",
        component: () => import("./views/users-management/permissions/Permissions.vue"),
        meta: { authRequired: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['permissions-all', 'permissions-view'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: "/expenses",
        name: "Expenses",
        component: () => import("./views/expense/Table.vue"),
        meta: { authRequired: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['expenses-all', 'expenses-view'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: "/expenses/add",
        name: "AddExpense",
        component: () => import("./views/expense/AddEdit.vue"),
        meta: { authRequired: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['expenses-all', 'expenses-create'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: '/expenses/:id',
        name: 'ExpenseDetail',
        component: () => import('./views/expense/ExpenseDetail.vue'),
        meta: { authRequired: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['expenses-all', 'expenses-view'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: '/expenses/edit/:id',
        name: 'EditExpense',
        component: () => import('./views/expense/AddEdit.vue'),
        meta: { authRequired: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['expenses-all', 'expenses-edit'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: '/bills',
        name: 'Bills',
        component: () => import('./views/bills/Table.vue'),
        meta: { authRequired: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['bills-all', 'bills-view'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: '/generate-bill',
        name: 'GenerateBill',
        component: () => import('./views/bills/GenerateBill.vue'),
        meta: { authRequired: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['bills-all', 'bills-generate'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: '/bill/:id',
        name: 'ViewBill',
        component: () => import('./views/bills/View.vue'),
        meta: { authRequired: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['bills-all', 'bills-view'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    // {
    //   path: '/bill/:id',
    //   name: 'EditBill',
    //   component: () => import('./views/bills/EditBill.vue'),
    //   meta: { authRequired: true },
    //   beforeEnter: (to, from, next) => {
    //       if (hasPermission(['bills-all', 'bills-edit'])) {
    //           next();
    //       } else {
    //           next('/unauthorized');
    //       }
    //   }
    // },
    {
        path: '/transfers',
        name: 'Transfers',
        component: () => import('./views/transfers/Table.vue'),
        meta: { authRequired: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['transfers-all', 'transfers-view'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: '/transfers/add',
        name: 'AddTransfer',
        component: () => import('./views/transfers/Add.vue'),
        meta: { authRequired: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['transfers-all', 'transfers-create'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: '/transfers/:id',
        name: 'ViewTransfer',
        component: () => import('./views/transfers/View.vue'),
        meta: { authRequired: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['transfers-all', 'transfers-view'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: '/payments',
        name: 'Payments',
        component: () => import('./views/payment/Table.vue'),
        meta: { authRequired: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['payments-all', 'payments-view'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: '/payments/add',
        name: 'AddPayment',
        component: () => import('./views/payment/AddEdit.vue'),
        meta: { authRequired: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['payments-all', 'payments-create'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: '/payments/:id',
        name: 'EditPayment',
        component: () => import('./views/payment/AddEdit.vue'),
        meta: { authRequired: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['payments-all', 'payments-edit'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: '/payments/detail/:id',
        name: 'ViewPayment',
        component: () => import('./views/payment/View.vue'),
        meta: { authRequired: true },
        beforeEnter: (to, from, next) => {
            if (hasPermission(['payments-all', 'payments-view'])) {
                next();
            } else {
                next('/unauthorized');
            }
        }
    },
    {
        path: '/settings',
        name: 'settings',
        meta: { authRequired: true },
        children: [
            {
                path: 'accounts',
                name: 'Accounts',
                component: () => import('./views/settings/accounts/Table.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['accounts-all', 'accounts-view'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'account/add',
                name: 'AddAccount',
                component: () => import('./views/settings/accounts/AddEdit.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['accounts-all', 'accounts-create'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'account/edit/:id',
                name: 'EditAccount',
                component: () => import('./views/settings/accounts/AddEdit.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['accounts-all', 'accounts-edit'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'statuses',
                name: 'Statuses',
                component: () => import('./views/settings/statuses/Table.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['statuses-all', 'statuses-view'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'status/add',
                name: 'AddStatus',
                component: () => import('./views/settings/statuses/AddEdit.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['statuses-all', 'statuses-create'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'status/edit/:id',
                name: 'EditStatus',
                component: () => import('./views/settings/statuses/AddEdit.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['statuses-all', 'statuses-edit'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            
            {
                path: 'order-statuses',
                name: 'orderStatuses',
                component: () => import('./views/settings/orderStatuses/Table.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['order-statuses-all', 'order-statuses-view'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'order-status/add',
                name: 'AddOrderStatus',
                component: () => import('./views/settings/orderStatuses/AddEdit.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['order-statuses-all', 'order-statuses-create'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'order-status/edit/:id',
                name: 'EditOrderStatus',
                component: () => import('./views/settings/orderStatuses/AddEdit.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['order-statuses-all', 'order-statuses-edit'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },

            {
                path: 'shipping-services',
                name: 'ShippingServices',
                component: () => import('./views/settings/shippingService/Table.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['shipping-services-all', 'shipping-services-view'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'shipping-service/add',
                name: 'AddShippingService',
                component: () => import('./views/settings/shippingService/AddEdit.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['shipping-services-all', 'shipping-services-create'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'shipping-service/edit/:id',
                name: 'EditShippingService',
                component: () => import('./views/settings/shippingService/AddEdit.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['shipping-services-all', 'shipping-services-edit'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'payment-types',
                name: 'PaymentTypes',
                component: () => import('./views/settings/paymentTypes/Table.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['payment-types-all', 'payment-types-view'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'payment-type/add',
                name: 'AddPaymentTypes',
                component: () => import('./views/settings/paymentTypes/AddEdit.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['payment-types-all', 'payment-types-create'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'payment-type/edit/:id',
                name: 'EditPaymentType',
                component: () => import('./views/settings/paymentTypes/AddEdit.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['payment-types-all', 'payment-types-edit'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'utilities',
                name: 'Utilities',
                component: () => import('./views/settings/utilities/Table.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['utilities-all', 'utilities-view'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'utility/add',
                name: 'AddUtility',
                component: () => import('./views/settings/utilities/AddEdit.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['utilities-all', 'utilities-create'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'utility/edit/:id',
                name: 'EditUtility',
                component: () => import('./views/settings/utilities/AddEdit.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['utilities-all', 'utilities-edit'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'expense-types',
                name: 'ExpenseTypes',
                component: () => import('./views/settings/expenseTypes/Table.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['expense-types-all', 'expense-types-view'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'expense-type/add',
                name: 'AddExpenseType',
                component: () => import('./views/settings/expenseTypes/AddEdit.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['expense-types-all', 'expense-types-create'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'expense-type/edit/:id',
                name: 'EditExpenseType',
                component: () => import('./views/settings/expenseTypes/AddEdit.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['expense-types-all', 'expense-types-edit'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
        ]
    },
    {
        path: '/db-sync',
        name: 'DBSync',
        meta: { authRequired: true },
        children: [
            {
                path: 'import-orders',
                name: 'ImportOrders',
                component: () => import('./views/db-sync/importOrders/Table.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['import-orders-all', 'import-orders-view'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'import-orders/add',
                name: 'AddImportOrder',
                component: () => import('./views/db-sync/importOrders/AddEdit.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['import-orders-all', 'import-orders-create'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'import-products',
                name: 'ImportProducts',
                component: () => import('./views/db-sync/importProducts/Table.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['import-products-all', 'import-products-view'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'import-products/add',
                name: 'AddImportProduct',
                component: () => import('./views/db-sync/importProducts/AddEdit.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['import-products-all', 'import-products-create'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'import-product-orders',
                name: 'ImportProductOrders',
                component: () => import('./views/db-sync/importProductOrders/Table.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['import-product-orders-all', 'import-product-orders-view'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'import-product-orders/add',
                name: 'AddImportProductOrder',
                component: () => import('./views/db-sync/importProductOrders/AddEdit.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['import-product-orders-all', 'import-product-orders-create'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'import-expenses-order-fulfillment',
                name: 'ImportExpensesOrderFulfillment',
                component: () => import('./views/db-sync/importExpensesOrderFulfillment/Table.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['import-expenses-all', 'import-expenses-view'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'import-expenses-order-fulfillment/add/:type',
                name: 'AddImportExpensesOrderFulfillment',
                component: () => import('./views/db-sync/importExpensesOrderFulfillment/AddEdit.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['import-expenses-all', 'import-expenses-create'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'import-expenses',
                name: 'ImportExpenses',
                component: () => import('./views/db-sync/importExpenses/Table.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['import-expenses-all', 'import-expenses-view'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'import-expenses/add/:type',
                name: 'AddImportExpenses',
                component: () => import('./views/db-sync/importExpenses/AddEdit.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['import-expenses-all', 'import-expenses-create'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'import-payments',
                name: 'ImportPayments',
                component: () => import('./views/db-sync/importPayments/Table.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['import-payments-all', 'import-payments-view'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
            {
                path: 'import-payments/add',
                name: 'AddImportPayment',
                component: () => import('./views/db-sync/importPayments/AddEdit.vue'),
                meta: { authRequired: true },
                beforeEnter: (to, from, next) => {
                    if (hasPermission(['import-payments-all', 'import-payments-create'])) {
                        next();
                    } else {
                        next('/unauthorized');
                    }
                }
            },
        ]
    },
    {
        path: "/forgot-password",
        name: "ForgotPassword",
        component: () => import("./views/account/forgot-password"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters["authApi/token"]) {
                    next({ name: "default" });
                } else {
                    next();
                }
            },
        },
    },
    {
        path: "/:pathMatch(.*)*",
        name: "NotFound",
        component: () => import("./views/NotFound.vue"),
    },
];